export default __webpack_public_path__ + "856b7c2e972954fe456e147e8ea5dfb4.png";